module.exports = __webpack_public_path__ + "static/media/icon-handshake.99a59934.svg";